import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { useStore } from '../../../../hooks'
import {
    CircularProgress,
    List,
    ListItem,
    ListItemText
} from '@material-ui/core';
import $http from '../../../../utils/$http';
import { ICompanyUser } from '../../../../models/ICompanyUser';

export interface DisplayRecipientsProps {
    userId: number,
    companyId: number
}

type Recipient = { label: string, id: number };

const DisplayConfiguredOrderRecipients = ({ userId, companyId }: DisplayRecipientsProps) => {
    const [isLoading, setIsLoading] = React.useState(true);
    const [orderRecipients, setOrderRecipients] = React.useState(new Array<Recipient>());

    React.useEffect(() => {
        getConfiguredOrderRecipients();
    }, [companyId]);

    const getConfiguredOrderRecipients = async () => {
        setIsLoading(true);
        const { recipientIds } = await $http.get<any>(`/user/customer/${userId}`)
        const companyUsers = await $http.get<Array<ICompanyUser>>(`/user/customer/company/${companyId}?includeSubsidiaries=true`)

        const recipients = companyUsers
            .filter(u => {
                return recipientIds.some((r: number) => r === u.id);
            })
            .map(u => {
                return {
                    label: `${u.firstName} ${u.lastName}`,
                    id: u.id
                } as Recipient
            });

        setOrderRecipients(recipients);
        setIsLoading(false);
    }

    if (isLoading) {
        return <CircularProgress />;
    }

    return <List>
        {orderRecipients.map(x =>
            <ListItem key={x.id}>
                <ListItemText
                    primary={x.label} />
            </ListItem>
        )}
    </List>;
}

export default inject('rootStore')(observer(DisplayConfiguredOrderRecipients))